export enum RelationObjectType {
  DOCUMENT = "documents.documentfile",
  PERSON = "people.person",
  COMPANY = "companies.company",
  DEAL = "deals.deal",
  MEETING = "meetings.meeting",
  NOTE = "notes.ainote",
  FOLDER = "documents.folder",
  THEME = "sourcing.theme",
  EMAIL_THREAD = "emails.thread",
  USER = "accounts.user",
  FUND = "fundraising.fund",
  OPPORTUNITY = "fundraising.opportunity",
}

export enum ThemeRelationMode {
  MULTI = "Multi",
  SINGLE = "Single",
}
